import { useEffect } from "react";

export type JsonLd = {
  "@type": string;
  [key: string]: unknown;
};

const SITE_URL = "https://xttkax.cn";

const DEFAULT_OG_IMAGE =
  "https://readdy.ai/api/search-image?query=editorial%20entertainment%20news%20collage%20with%20warm%20coral%20and%20amber%20tones%2C%20movie%20film%20and%20music%20elements%2C%20modern%20magazine%20layout%20composition%2C%20vibrant%20yet%20refined%20warm%20palette&width=1600&height=900&seq=chigua-og&orientation=landscape";

function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setProperty(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url: string) {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

function setJsonLd(schemas: JsonLd[]) {
  document.querySelectorAll("script[data-page-jsonld]").forEach((node) => node.remove());
  schemas.forEach((schema, i) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-page-jsonld", "true");
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  });
}

export function usePageMeta(options: {
  title: string;
  description: string;
  path: string;
  keywords?: string;
  ogType?: "website" | "article";
  schema?: JsonLd[];
}) {
  const { title, description, path, keywords, ogType = "website", schema } = options;
  useEffect(() => {
    const fullTitle = `${title}｜吃瓜17`;
    const url = `${SITE_URL}${path}`;
    document.title = fullTitle;
    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
    setMeta("robots", "index, follow, max-image-preview:large");
    setProperty("og:type", ogType);
    setProperty("og:site_name", "吃瓜17");
    setProperty("og:locale", "zh_CN");
    setProperty("og:title", fullTitle);
    setProperty("og:description", description);
    setProperty("og:url", url);
    setProperty("og:image", DEFAULT_OG_IMAGE);
    setProperty("twitter:card", "summary_large_image");
    setProperty("twitter:title", fullTitle);
    setProperty("twitter:description", description);
    setCanonical(url);
    if (schema && schema.length) setJsonLd(schema);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, ogType]);
}